export const GET_LANGUAGE = 'GET_LANGUAGE';
export const SET_LANGUAGE = 'SET_LANGUAGE';

export const FETCH_PERIODS = "FETCH_PERIODS";
export const SAVE_PERIODS = "SAVE_PERIODS";

export const SNACKBAR_SETTING = 'SNACKBAR_SETTING';
